module.exports = __webpack_public_path__ + "static/media/ico_simulation_eye_crowsfeet.1e50d48b.png";